import React from "react";
import ReactDOM from "react-dom";
import { observer, inject } from "mobx-react";
import { extendObservable, action } from "mobx";
import { injectIntl } from "react-intl";
import { MentionsInput, Mention } from "react-mentions";
import { Button } from "react-bootstrap";
import ReactMarkdown from "react-markdown";

import DeleteButton from "../common_components/DeleteButton";
import { MENTIONS_CLASS_NAMES } from "./constants";

@injectIntl
@inject("rootStore")
@observer
export default class EditableWithMentions extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {
      inputText: props.value,
      showSuccess: false,
      editMode: false,
      textTooLarge: false
    });
  }

  render() {
    const {
      intl,
      rootStore,
      value,
      note,
      canEdit,
      placeholder,
      showDelete,
      canDelete,
      maxLength,
      className
    } = this.props;
    const showButtonContainer = showDelete && canDelete;
    const buttonClass = "editable-container-with-button";

    return (
      <div
        className={`editable-container editable-with-mentions-container ${buttonClass} ${className}`}
      >
        <div hidden={!this.editMode}>
          <MentionsInput
            classNames={MENTIONS_CLASS_NAMES}
            ref={element => (this.textAreaComponent = element)}
            value={this.inputText}
            onChange={this.handleInputTextChange}
            onKeyDown={this.checkKey}
            onBlur={this.finishEdit}
            disabled={!canEdit}
            placeholder={placeholder}
            displayTransform={(id, display, type) => `@${display}`}
            markup="@[__display__](/profiles/__id__)"
          >
            <Mention
              className={MENTIONS_CLASS_NAMES.mentions__mention}
              trigger="@"
              data={rootStore.allMembersForMentions}
              appendSpaceOnAdd
            />
          </MentionsInput>
        </div>

        <div
          className="react-markdown-container"
          onClick={canEdit ? this.toggleEditMode : () => {}}
          hidden={this.editMode}
        >
          <ReactMarkdown source={this.inputText} />
        </div>

        <div className=" editable-buttons-container">
          {this.renderReplyButton()}
          {this.renderDeleteButton()}
        </div>

        {this.showSuccess && (
          <div className="editable-check-mark-container">
            <i
              className="fa fa-check-circle"
              style={{ fontSize: "1.5em", color: "#1C8D8E" }}
            />
          </div>
        )}

        {this.textTooLarge && (
          <div style={{}}>
            <span className="fa fa-exclamation-circle" />
            {intl.formatMessage({ id: "note_text_too_large" })}
          </div>
        )}
      </div>
    );
  }

  renderReplyButton = () => {
    const { note, comment } = this.props;

    // show reply button only if comment param is present
    // and if the comment is not created by the current user
    if (!comment || comment.creatorId === note.rootStore.user.id) {
      return;
    }

    return (
      <Button
        bsStyle="default"
        className="editable-reply-button"
        onClick={this.handleReplyButton}
      >
        <i className="fa fa-reply" />
      </Button>
    );
  };

  renderDeleteButton = () => {
    const { canDelete, showDelete, onDelete } = this.props;

    if (showDelete && canDelete) {
      return <DeleteButton onDelete={onDelete} />;
    }
  };

  handleInputTextChange = (e, newValue, newPlainTextValue, mentions) => {
    const { maxLength } = this.props;

    this.inputText = newValue;

    if (maxLength && newValue.length >= maxLength) {
      this.textTooLarge = true;
    } else {
      this.textTooLarge = false;
    }
  };

  checkKey = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      this.preventPropagation(e);
      // this will trigger onBlur's finishEdit() method
      this.ref.blur();
      // this.textAreaComponent.blur();
      // this.finishEdit(e)
    }
  };

  @action
  finishEdit = e => {
    const { value } = this.props;

    if (
      this.inputText.trim() &&
      value !== this.inputText &&
      !this.textTooLarge
    ) {
      this.props.onEdit(this.inputText);
      this.triggerSuccess();
    } else {
      this.inputText = value;
    }

    this.toggleEditMode();
  };

  preventPropagation = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  // this is needed to prevent modal from close, it may be a bug of onKeyDown of TextareaAutosize
  @action
  escFunction = e => {
    const { value } = this.props;

    if (e.key === "Escape") {
      this.preventPropagation(e);
      this.inputText = value;
      e.target.blur();
    }
  };

  @action
  triggerSuccess = () => {
    this.showSuccess = true;
    setTimeout(() => {
      this.showSuccess = false;
    }, 3000);
  };

  @action
  handleReplyButton = () => {
    const { note, comment } = this.props;

    note.newCommentText = `@[${comment.creator.name}](/profiles/${
      comment.creator.id
    }) `;
    note.commentFormTextAreaRef.focus();
    note.commentFormTextAreaRef.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  };

  @action
  toggleEditMode = () => {
    if (this.props.canEdit) {
      this.editMode = !this.editMode;

      this.focusTextArea();
    }
  };

  focusTextArea() {
    if (!this.textAreaRef) {
      this.textAreaRef = ReactDOM.findDOMNode(
        this.textAreaComponent
      ).childNodes[0].childNodes[1];
    }

    setTimeout(() => {
      this.textAreaRef.focus();
    }, 100);
  }

  componentDidMount() {
    this.ref = ReactDOM.findDOMNode(
      this.textAreaComponent
    ).childNodes[0].childNodes[1];
    this.ref.addEventListener("keydown", this.escFunction, true);
  }

  componentWillUnmount() {
    this.ref.removeEventListener("keydown", this.escFunction, true);
  }
}

EditableWithMentions.propTypes = {};
